<script>
import Modal from "@/components/_Shared/Modal";
import InputGroup from "@/components/_Shared/InputGroup";
import { mapActions } from "vuex";

export default {
  components: {
    InputGroup,
    Modal
  },
  data() {
    return {
      street: "",
      streetNumber: "",
      city: "",
      complement: "",
      reference: "",
      location: null,
      addressComponents: null,
      loader: false
    };
  },

  methods: {
    ...mapActions("newAddress", [
      "setLocation",
      "setAddressComponents",
      "setComplement",
      "setReference",
      "setStreetNumber",
      "setStreet"
    ]),

    toastError(e) {
      this.loader = false;
      this.$toasted.error(e);
    },

    async search() {
      this.loader = true;

      try {
        let valid = await this.$validator.validateAll();

        if (!valid) throw "Ocorreu um erro, verifique os dados informados!";

        await this.getPlace();
        this.setStreet(this.street);
        this.setComplement(this.complement);
        this.setReference(this.reference);
        this.setStreetNumber(this.streetNumber);
      } catch (e) {
        this.toastError(e);
      }
    },

    async getPlace() {
      try {
        let params = {
          fields: ["place_id"],
          query: this.street + " " + this.streetNumber + " " + this.city
        };

        let map = document.getElementById("service-helper");
        let service = new google.maps.places.PlacesService(map);

        service.findPlaceFromQuery(params, (results, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK)
            this.getPlaceDetails(service, results[0].place_id);
          else this.toastError("Endereço não encontrado!");
        });
      } catch (e) {
        throw e;
      }
    },

    async getPlaceDetails(service, placeId) {
      try {
        let params = {
          fields: ["address_components", "geometry.location"],
          placeId
        };

        await service.getDetails(params, async (res, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            this.location = res.geometry.location;
            this.addressComponents = res.address_components;
          } else this.toastError("Detalhes do endereço não encontrado!");
        });
      } catch (e) {
        throw e;
      }
    }
  },

  watch: {
    location(location) {
      try {
        this.setLocation(location);
      } catch (e) {
        this.toastError(e);
      }
    },
    async addressComponents(addressComponents) {
      try {
        await this.setAddressComponents(addressComponents);
        this.$emit("next");
        this.loader = false;
      } catch (e) {
        this.toastError(e);
      }
    }
  }
};
</script>

<template>
  <modal title="INFORME O ENDEREÇO" subtitle="Digite abaixo os dados do seu endereço" size="md">
    <template slot="body">
      <div id="service-helper"></div>

      <form @submit.prevent="search()">
        <div class="form-group">
          <InputGroup
            class="ym-disable-keys"
            :error="errors.first('endereço')"
            v-validate="'required'"
            v-model="street"
            name="endereço"
            label="endereço"
          />

          <InputGroup
            class="ym-disable-keys"
            :error="errors.first('numero')"
            v-validate="'numeric'"
            v-model="streetNumber"
            name="numero"
            label="número"
          />
        </div>

        <div class="form-group">
          <InputGroup
            class="ym-disable-keys"
            :error="errors.first('cidade')"
            v-validate="'required'"
            v-model="city"
            name="cidade"
            label="cidade"
          />
        </div>

        <div class="form-group">
          <InputGroup
            class="ym-disable-keys"
            :error="errors.first('complemento')"
            v-validate="'min:2'"
            v-model="complement"
            name="complemento"
            label="complemento"
          />

          <InputGroup
            class="ym-disable-keys"
            :error="errors.first('referencia')"
            v-validate="'min:5'"
            v-model="reference"
            name="referencia"
            label="referência"
          />
        </div>

        <button v-show="false" type="submit"></button>
      </form>
    </template>

    <template slot="footer">
      <div class="btn bg-gray" @click="$emit('close')">fechar</div>
      <div class="btn bg-purple" :class="{'btn--loading': loader}" @click="search()">
        <span>buscar</span>
      </div>
    </template>
  </modal>
</template>

<style scoped>
hr {
  border-top: none !important;
  border-bottom-color: #eee !important;
  background-color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Addresses/NewAddress/EnterAddress.vue